
import React, { useState, useEffect, useRef } from "react";
import {View, Text, TextInput,  Dimensions, TouchableOpacity, Image, ScrollView,} from "react-native";
import ModalAlert from "../../common/ModalAlert";
import QuickLinks from "./QuickLinks";
import "react-datepicker/dist/react-datepicker.css";
import CustomButton from "../../common/CustomButton";
import CustomInput from "../../common/CustomInput";
import { get } from "lodash";
import { updateEmail, getCorpUserDetails} from "./../../api/serviceRequest";
import { getUserProfileImage, getUserDetails, uploadUserImage, sendOtpApi} from "./../../api/apiManager";
import Loader from "./../../common/Loader";
import * as RootNavigation from "../../utilities/RootNavigation";
import { useLogin } from '../../context/loginProvider';
import CountdownTimer from "../../common/CTimer.web";
import useStyles from "./CustomerDetails_Styles";
import CText from "../../common/CText";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;
// create a component
const CustomerDetails = (props) => {
  const styles = useStyles();
  const [loading, setLoading] = useState(false);
  const [imgData, setImgData] = useState("");
  const [userData, setUserData] = useState("");
  const [email, setEmail] = useState("");
  const [emailEdit, setEmailEdit] = useState(false);
  const [userId, setUserId] = useState("");
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [enableUpdate, setEnableUpdate] = useState(false);
  const [corpUserData, setCorpUserData] = useState("");
  const [isCorporate, setIsCorporate] = useState(false);
  const [isUpdateUserId, setIsUpdateUserId] = useState(false);
  const [frontImage, setFrontImage] = useState();
  const [previewImage, setPreviewImage] = useState("");
  const [upddatedMobile, setUpddatedMobile] = useState();
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [isMobileEdit, setIsMobileEdit] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const counterRef = useRef(null);
  const [alertModal, setAlertModal] = useState({ title: "", status: "", message: "", navigateScreen: "",actionButton: "",});
  const [otpData, setOtpData] = useState("");
  const [otpMsg, setOtpMsg] = useState("");
  const [otp, setOtp] = useState();
  const otpPattern = /^\d{6}$/;
  const emailPattern = /^([a-zA-Z0-9_\.]+)@([a-zA-Z0-9_\.]+)\.([a-zA-Z]{2,3})$/;
  const fileInputRef = useRef();

  const getProfileImage = () => {
    setLoading(true);
    getUserProfileImage()
      .then((res) => {
        setLoading(false);
        setImgData(res);
        global.userProfileImg = res
      })
      .catch((err) => { setLoading(false);});
  };

  const getProfileDetails = () => {
    setLoading(true);
    getUserDetails()
      .then((res) => {
        console.log("getUserDetails", res);
        setLoading(false);
        setUpddatedMobile(get(res, "mobileNo", ""));
        global.mobileNo = get(res, "mobileNo", "");
        setEmail(get(res, "emailId", ""));
        setUserId(get(res, "userId", ""));
        setUserData(res);
      })
      .catch((err) => {
        setLoading(false);
        if(err?.message == "Invalid token specified"){ setIsLoggedIn(false)}
      });
  };

  useEffect(() => {
    if (get(userData, "mobileNo", "")) {
      if ( upddatedMobile != get(userData, "mobileNo", "") || email != get(userData, "emailId", "")  ) {
        if ( email != "" &&  emailPattern.test(email) && upddatedMobile.length == 10 ) {
          setEnableUpdate(true); } else { setEnableUpdate(false);}
      } }
  }, [upddatedMobile, email]);

  const updateEmailIdOtp = () => {
    setLoading(true);
    let params = { action: "OTP",};
    updateEmail(params)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode == 200) {
          setOtpModalVisible(true);
          setOtpData(res?.data);
          setOtpMsg(res?.message)
        } else {
          setAlertModalVisible(true);
          setAlertModal({ title: "Error", status: "error", message: res.message,navigateScreen: "",actionButton: "OK",});
        }
      })
      .catch((err) => {
        setLoading(false);
        setAlertModalVisible(true);
        setAlertModal({ title: "Error", status: "error", message: err.message,navigateScreen: "",actionButton: "OK",});
      });
  };

  const updateEmailId = () => {
    setLoading(true);
    let params = { action: "UPDATE", otp: otp, requestId: otpData.requestId, journeyId: otpData.journeyId, emailId: email, };
    updateEmail(params)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode < 0 || res?.statusCode == 500) {
          setAlertModalVisible(true);
          setOtpModalVisible(false);
          setAlertModal({ title: "Error", status: "error", message: res.message,navigateScreen: "",actionButton: "OK",});
        } else {
          setOtpModalVisible(false);
          setAlertModalVisible(true);
          setAlertModal({ title: "Success", status: "success", message: res.message,  navigateScreen: "", actionButton: "OK",});
        }
      }).catch((err) => {
        setAlertModalVisible(true);
        setLoading(false);
        setAlertModal({ title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK",});
      });
  };

  const uploadProfileImage = (reqObj) => {
    setLoading(true);
    uploadUserImage(reqObj)
      .then((res) => {
        setLoading(false);
        getProfileImage();
      }).catch((err) => {
        setLoading(false);
        if(err?.message == "Invalid token specified"){setIsLoggedIn(false)}
      });
  };

  const getCorpProfileDetails = () => {
    setLoading(true);
    getCorpUserDetails()
      .then((res) => {
        setLoading(false);
        setCorpUserData(res);
      }).catch((err) => { setLoading(false);});
  };

  useEffect(() => {
      getProfileImage();
      getProfileDetails();
      getCorpProfileDetails();
  }, []);

  useEffect(() => {
    if (previewImage) {
      var reqObj = new FormData();
      reqObj.append("profileImage", previewImage);
      uploadProfileImage(reqObj);
    }
  }, [previewImage]);

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {setFrontImage(file); } else { setFrontImage(null); }
  };

  useEffect(() => { if (frontImage) {setPreviewImage(frontImage); } else { setPreviewImage(null);} }, [frontImage]);

  const handleSubmit = (event) => {
    event.preventDefault();
    let element = document.getElementById("uploadFile");
    element.click();
  };

  const onChangeUserId = (e) => { setUserId(e);};

  const getOtp = (params) => {
    setLoading(true);
    sendOtpApi(params)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode === 1003) {
          setOtpData(res);
          setOtpModalVisible(true);
        } else {
          setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK",});
          setAlertModalVisible(true);
        }
      }).catch((err) => {
        setAlertModal({ title: "Error", status: "error", message: err.message, navigateScreen: "", actionButton: "OK",});
        setAlertModalVisible(true);
        setLoading(false);
      });
  };

  const resendOTP = (params) => {
    setOtp("");
    setLoading(true);
    sendOtpApi(params)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode === 1003) { setOtpData(res);} else {
          setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK",});
          setAlertModalVisible(true);
        }
      }).catch((err) => { setLoading(false); });
  };

  const onCloseModal = () => { setAlertModalVisible(false); setIsMobileEdit(false); setOtp(""); };



  return (
    <View>
      {isUpdateUserId ? (
        null ) : (
        <View style={[styles.mainContainer]}>
      
            <ScrollView>
              <View style={styles.container}>
                 <View style={{ alignSelf: "center" }}>
                  <View style={styles.inputViewStyle}>
                    <View>  
                      <Text style={styles.lableTextStyle}>{"User Id"}</Text>
                      <TextInput 
                      editable={false} 
                      value={userId} 
                      onChangeText={onChangeUserId} 
                      style={ get(userData, "userIdCustomizable", "") ? [ styles.textInputStyle] : styles.textInputStyle} 
                      />
                      {false && ( <TouchableOpacity onPress={() => { setIsUpdateUserId(true); }} style={styles.getOtpWidget}> 
                      <CText.updateText>{"Update"} </CText.updateText></TouchableOpacity> )}
                    </View>
                  </View>
                  <View style={styles.inputViewStyle}>
                    <View>
                      <Text style={styles.lableTextStyle}> {"Customer Name"} </Text>
                      <TextInput 
                      style={styles.textInputStyle} 
                      editable={false} 
                      value={ get(userData, "fullName", "")} 
                      />
                    </View>
                  </View>
                  <View style={styles.inputViewStyle}>
                    <View>
                      <Text style={styles.lableTextStyle}>{"Mobile (O)"}</Text>
                      <TextInput 
                      value={upddatedMobile} 
                      maxLength={10} 
                      style={[styles.textInputStyle]} 
                      editable={false} 
                      onChangeText={(t) => isNaN(t) ? "" : setUpddatedMobile(t)} 
                      />
                    </View>
                    <View style={styles.updateContainerViewStyle}>
                      <CustomButton style={styles.modifyBtn} color={"#3e4a5e"} text={"Modify"} fontSize={12} onPress={() => {RootNavigation.navigate("ServiceRequest/MobileUpdate", {screen: "Update mobile number" });global.activeScreen = "ServiceRequest" }} />
                    </View>
                  </View>
                  <View style={styles.inputViewStyle}>
                    <View>
                      <Text style={styles.lableTextStyle}>{"Email Id"}</Text>
                      <CustomInput 
                      onValueChanged={(text) => { setEmail(text) }}
                       value={email} 
                       requiredEndText={true}
                        blurOnSubmit={false}
                        pattern={emailPattern}
                        editable={emailEdit ? true : false}
                        errorMessage={"Please enter valid email id"}
                        style={[styles.textInputStyle, { backgroundColor: emailEdit ? "#ffffff" : "#f8f8f8",borderColor: "#c3c3c3" }]}
                        secureTextEntry={false}
                        maxLength={100}
                      />
                    </View>
                    <View style={[styles.updateContainerViewStyle]}>
                      {!emailEdit ? (<CustomButton onPress={() => setEmailEdit(true)} text={"Modify"} color={"#3e4a5e"} fontSize={12} style={styles.modifyBtn} />) : 
                        ( !emailPattern.test(email) ? <CustomButton disable = {true} onPress={() => {}}  text={"Save"} />: 
                         <CustomButton disable = {!emailPattern.test(email) ? true : false } onPress={() => { updateEmailIdOtp(), setEmailEdit(false);}} text={"Save"} />)}
                    </View>
                  </View>
                  <View style={[styles.inputViewStyle]}>
                    <View>
                      <Text style={styles.lableTextStyle}>{"KYC "}</Text>
                      <TextInput 
                      style={styles.textInputStyle} 
                      editable={false} 
                      value={get(userData, "kyc", "")} 
                      />
                    </View>
                    
                  </View>
                  <View style={styles.inputViewStyle}>
                    <View>
                      <Text style={styles.lableTextStyle}>{"Address Line 1"} </Text>
                      <View style={[   styles.textInputStyle,{ height: "auto", paddingVertical: 5,minHeight:36.6 }]}>
                        <CText.adrsText>  {get(userData, "address1", "")}</CText.adrsText></View>
                    </View>
                  </View>
                  <View style={styles.inputViewStyle}>
                    <View>
                      <Text style={styles.lableTextStyle}>{"Address Line 2"} </Text>
                      <View style={[styles.textInputStyle,{height: "auto", paddingVertical: 5,minHeight:36.6 }]}> 
                       <CText.adrsText> {get(userData, "address2", "")} </CText.adrsText> 
                      </View>
                    </View>
                  </View>
                  <View style={styles.inputViewStyle}>
                    <View>
                      <Text style={styles.lableTextStyle}> {"Address Line 3"} </Text>
                      <View style={[styles.textInputStyle,{ height: "auto", paddingVertical: 5,minHeight:36.6 }]}> 
                      <CText.adrsText> {get(userData, "address3", "")} </CText.adrsText> 
                      </View>
                    </View>
                  </View>
                  <View style={styles.mobileViewStyle}>
                    <View style={styles.inputViewStyle}>
                        <Text style={styles.lableTextStyle}>{"City1"}</Text> 
                        <TextInput 
                        style={[styles.textInputStyle, { paddingRight: 10 }]} 
                        editable={false} 
                        value={get(userData, "city", "")} 
                        />
                    </View>
                    <View style={styles.inputViewStyle}>
                        <Text style={styles.lableTextStyle}>{"District"}</Text> 
                        <TextInput 
                        style={styles.textInputStyle} 
                        editable={false} 
                        value={get(userData, "district", "")} 
                        />
                    </View>
                    <View style={styles.inputViewStyle}>
                        <Text style={styles.lableTextStyle}>{"State"}</Text> 
                        <TextInput 
                        style={styles.textInputStyle} 
                        editable={false} 
                        value={get(userData, "state", "")} 
                        />
                    </View>
                    <View style={styles.inputViewStyle}>
                        <Text style={styles.lableTextStyle}>{"Pincode"}</Text> 
                        <TextInput 
                        style={styles.textInputStyle} 
                        editable={false} 
                        value={get(userData, "zipCode", "")}
                         />
                    </View>
                    <View style={styles.inputViewStyle}>
                        <Text style={styles.lableTextStyle}>{"Gender"}</Text> 
                        <TextInput 
                        style={styles.textInputStyle} 
                        editable={false} 
                        value={ get(userData, "gender", "") == "F" ? "Female" : get(userData, "gender", "") == "M" ? "Male" : get(userData, "gender", "") == "O" ? "Other" : "NA" } 
                        />
                    </View>
                  </View>
                </View> 
                <View style={styles.imgDataWidget}   >
                  <View style={{ flexDirection: isSmallDevice ? "column" : "row" }} >
                    {imgData == "" || imgData == null ? ( <Image source={require("../../assets/images/default_profile.png")} style={styles.defaultPic} />
                    ) : (  <Image source={{ uri: `data:image/png;base64,${imgData}` }} style={styles.profilePic} /> )}
                    <View style={styles.uploadImgWidget} >
                      <input 
                      type="file" 
                      onChange={onFileChange} 
                      style={{ display: "none" }} 
                      id="uploadFile" accept="image/*" 
                      ref={fileInputRef} 
                      />
                      <TouchableOpacity  onPress={handleSubmit} style={styles.uploadImgLink} > 
                      <CText.updatePicText> {"Update Picture"} </CText.updatePicText>  
                      </TouchableOpacity>
                    </View>
                  </View>
                  <View style={styles.webViewStyle}>
                    <View style={styles.inputViewStyle}>
                      <View>
                        <Text style={styles.lableTextStyle}>{"City"}</Text> 
                        <TextInput 
                        style={[styles.textInputStyle, { paddingRight: 10 }]} 
                         editable={false} 
                         value={get(userData, "city", "")}
                          />
                      </View>
                    </View>
                    <View style={styles.inputViewStyle}>
                      <View>
                        <Text style={styles.lableTextStyle}>{"District"}</Text>
                        <TextInput 
                        style={styles.textInputStyle} 
                        editable={false} 
                        value={get(userData, "district", "")}
                        />
                      </View>
                    </View>
                    <View style={styles.inputViewStyle}>
                      <View>
                        <Text style={styles.lableTextStyle}>{"State"}</Text> 
                        <TextInput 
                        style={styles.textInputStyle} 
                        editable={false} 
                        value={get(userData, "state", "")} 
                        />
                      </View>
                    </View>
                    <View style={styles.inputViewStyle}>
                      <View>
                        <Text style={styles.lableTextStyle}>{"Pincode"}</Text> 
                        <TextInput 
                        style={styles.textInputStyle} 
                        editable={false} 
                        value={get(userData, "zipCode", "")} 
                        />
                      </View>
                    </View>
                    <View style={styles.inputViewStyle}>
                      <View>
                        <Text style={styles.lableTextStyle}>{"Gender"}</Text>
                        <TextInput
                          style={styles.textInputStyle}
                          editable={false}
                          value={ get(userData, "gender", "") == "F" ? "Female" : get(userData, "gender", "") == "M" ? "Male" : get(userData, "gender", "") == "O" ? "Other": "NA"}
                        />
                      </View>
                    </View>
                  </View>
                </View> 
              </View>
              <View style={styles.quickLinkViewStyle}>
                <QuickLinks navigation={props.navigation} activeScreen={"Pool Account Details"} setScreen={props.setScreen} setIsManual={props.setIsManual} />
              </View>
            </ScrollView>
          
          {loading && <Loader />}
          {otpModalVisible ? (
            <View style={styles.overlayViewStyle}>
              <View style={styles.overlayContainer}>
                <View style={styles.overlay}>
                  <View style={styles.overlayContentViewStyle}>
                    <Text style={styles.enterOtpTextStyle}>{"Enter OTP"}</Text>
                    <Text style={styles.otpDescTextStyle}> {otpMsg && otpMsg } </Text>
                    <View style={{ alignSelf: "center" }}>
                      <CustomInput
                        onValueChanged={(e) => setOtp(e)}
                        value={otp}
                        keyboardType="numeric"
                        pattern={/^\d{6}$/}
                        errorMessage={"Enter Valid OTP"}
                        maxLength={6}
                        style={[styles.otpInputViewStyle, { alignSelf: "center" }]}
                      />
                    </View>
                    <View style={styles.resendViewStyle}>
                    <CountdownTimer
                        requestOtp={otpModalVisible}
                        onClickGetOtp={() =>{
                         let reqObj = { type: "updateProfile", flag: "1", id: get(userData, "userId", ""), };
                         resendOTP(reqObj)
                        }}
                        counterRef={counterRef} />
                    </View>
                    <View style={styles.submitBtnWrapper}>
                      <CustomButton text={"Submit"} onPress={() => { !otpPattern.test(otp) ? "" : updateEmailId();  }} disable={!otpPattern.test(otp) ? true : false} />
                    </View>
                  </View>
                </View>
              </View>
            </View>
          ) : null}
          {alertModalVisible ? (
            <View style={styles.overlayViewStyle}>
              <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen}  actionButton={"OK"} onCloseModal={onCloseModal} />
            </View>) : null}
        </View>
      )}
    </View>
  );
};
//make this component available to the app
export default CustomerDetails;

